<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='系统参数设置' label2="修改参数信息" url="/system/dict/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">数据类型：</label>
            <div class="col-lg-3">
              <el-form-item prop="dictname" :rules="{required: true, message: '数据类型不能为空', trigger: 'blur'}">
                <el-input v-model="form.dictname" disabled></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">参数名称：</label>
            <div class="col-lg-3">
              <el-form-item prop="dictitemname" :rules="{required: true, message: '参数名称不能为空', trigger: 'blur'}">
                <el-input v-model="form.dictitemname"></el-input>
              </el-form-item>
            </div>
            <label class="col-lg-2 col-form-label">参数值：</label>
            <div class="col-lg-3">
              <el-form-item prop="dictitemvalue" :rules="{required: true, message: '参数值不能为空', trigger: 'blur'}">
                <el-input v-model="form.dictitemvalue"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">参数类型：</label>
            <div class="col-lg-3">
              <el-form-item prop="dictitemtype" :rules="{required: true, message: '参数类型不能为空', trigger: 'blur'}">
                <el-input v-model="form.dictitemtype"></el-input>
              </el-form-item>
            </div>
            <label class="col-lg-2 col-form-label">显示顺序：</label>
            <div class="col-lg-3">
              <el-form-item prop="orderindex" :rules="{required: true, message: '显示顺序不能为空', trigger: 'blur'}">
                <el-input v-model="form.orderindex"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12" style="text-align: center">
                  <SaveButton :url="saveUrl" back="/system/dict/list"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default{
  name: 'DictEdit',
  data () {
    return {
      form: {
        id: '',
        dictname: '',
        dictitemname: '',
        dictitemvalue: '',
        dictitemtype: '',
        orderindex: '',
        dictid: '',
        token: ''
      },
      saveUrl: this.$utils.Url.system + '/systemapi/dictitem/update'
    }
  },
  mounted: function () {
    var that = this
    this.form.token = sessionStorage.getItem('token')
    this.form.id = this.$route.params.id
    this.form.dictname = this.$route.params.dictname
    // 获取数据字典信息
    var args = {
      id: this.form.id,
      token: this.form.token
    }
    this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/dictitem/info', args, function (data) {
      that.form.dictitemname = data.Data.DictItemName
      that.form.dictitemvalue = data.Data.DictItemValue
      that.form.dictitemtype = data.Data.DictItemType
      that.form.orderindex = data.Data.OrderIndex
      that.form.dictid = data.Data.DictID
    }, null, null)
  }
}
</script>

<style>
</style>
